const FormResources = {

    form_data:{
        email: '',
        recaptcha: ''
    },

    form_format:[
        {
            css_class:  'col-md-12',
            type:       'email',
            maxlength:  100,
            disabled:   false,
            step:       '',
            name:       'Email:',
            model_name: 'email',
            ref:        'email_input',
            ref_alt:    'email_input_alt',
            required:   true,
        },
    ]

}

export default FormResources;